// extracted by mini-css-extract-plugin
export var displayNone = "_uk-6";
export var imgContainer = "_uk-2";
export var overflowHidden = "_uk-3";
export var productInfoCardButtonContainer = "_uk-5";
export var productTitleText = "_uk-4";
export var rightArrow = "_uk-1";
export var rightArrowContainer = "_uk-0";